import { useEffect } from "react";
import { useQuery } from "../../Utils";

export default function AuthenticateMobile() {
  const query = useQuery();

  useEffect(() => {
    const detectPlatform = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "ios";
      }

      if (/android/i.test(userAgent)) {
        return "android";
      }

      return "unknown";
    };

    const attemptDeepLink = () => {
      const platform = detectPlatform();
      const params = new URLSearchParams();

      for (const [key, value] of query.entries()) {
        params.set(key, value);
      }

      const queryString = params.toString();

      if (platform === "ios") {
        window.location.href = `com.humanplusplus.sudowriteapp://authenticate_mobile/email-sign-in-verify?${queryString}`;
      } else if (platform === "android") {
        window.location.href = `intent://authenticate_mobile/email-sign-in-verify?${queryString}#Intent;package=com.humanplusplus.sudowrite;scheme=sudowrite;end`;
      }
    };

    if (detectPlatform() !== "unknown") {
      attemptDeepLink();
    }

    const timer = setTimeout(() => {
      const params = new URLSearchParams();

      for (const [key, value] of query.entries()) {
        params.set(key, value);
      }

      window.location.href = `/email-sign-in-verify?${params.toString()}`;
    }, 1000);

    return () => clearTimeout(timer);
  }, [query]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontFamily: "Arial, sans-serif",
        flexDirection: "column",
      }}
    >
      <h2>Opening Sudowrite...</h2>
      <p>Attempting to open the Sudowrite app. If it doesn't open, you'll be redirected to the web version.</p>
    </div>
  );
}
